import { render, staticRenderFns } from "./SettingsPrivacyRules.vue?vue&type=template&id=8ede3d4e&scoped=true&"
import script from "./SettingsPrivacyRules.vue?vue&type=script&lang=js&"
export * from "./SettingsPrivacyRules.vue?vue&type=script&lang=js&"
import style0 from "./SettingsPrivacyRules.vue?vue&type=style&index=0&id=8ede3d4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ede3d4e",
  null
  
)

export default component.exports